import { render } from "./bindUserDialog.vue?vue&type=template&id=504e8401"
import script from "./bindUserDialog.vue?vue&type=script&lang=js"
export * from "./bindUserDialog.vue?vue&type=script&lang=js"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__